// Round L — "Vorige weken": pure helpers for the past-weeks list on /weekstand.
export function pastWeekSummary(week) {
  const top = week?.standings?.[0];
  const nobody = !week?.winners?.length || !top || top.points <= 0;
  return {
    title: `Week ${week?.iso_week}`,
    label: week?.has_season ? (week.focus_category || week.season_name || "Seizoen") : "zonder seizoen",
    winners: nobody ? [] : week.winners,
    points: nobody ? 0 : top.points,
    nobody,
  };
}

export function weekDates(week) {
  const fmt = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("nl-NL", { day: "numeric", month: "short" });
  return week?.starts_on && week?.ends_on ? `${fmt(week.starts_on)} – ${fmt(week.ends_on)}` : "";
}
